import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import Faq from "../pages/Faq";
import FleetWideResult from "../pages/FleetWideResult";
import MaintenanceScreen from "../pages/MaintenanceScreen";

export default function AppNavigation() {

  return (
    <Routes>
      <Route exact path="/" element={<Home />}></Route>
      <Route exact path="/faqs" element={<Faq />}></Route>
      <Route exact path="/fleetwideresult" element={<FleetWideResult />} ></Route> 
      <Route exact path="/maintenance" element={<MaintenanceScreen />}></Route>
    </Routes>
  );
}
